export default __webpack_public_path__ + "static/media/bi-mat-cua-gio.2e4a026d.png";